(function () {
  window.addEventListener('cartcount:update', function () {
    var form = document.querySelector('[data-sc-recalculate-message]');
    if (!form) return;
    var response = form.querySelector('[data-cartshipping-response]');
    if (!response || !response.classList.contains('visible')) return;
    response.querySelector('[data-cartshipping-message]').textContent = form.dataset.scRecalculateMessage;
    response.querySelector('[data-cartshipping-rates]').textContent = '';
  });
})();
